import React from "react";
import {
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CRow,
  CButton,
  CCardHeader,
} from "@coreui/react";
import { useHistory } from "react-router-dom";

import BookingByID from "components/BookingByID";
import Loader from "components/Loader";
import Header from "components/Header";
import Finish from "components/Finish";

function GetReservation({ events, showQR, onGetReservation, code }) {
  const history = useHistory();
  const mapEvents = () =>
    events.map(({ id, description }) => ({
      value: id,
      label: description,
    }));
  return (
    <CContainer>
      <CRow className="justify-content-center">
        <Header text="BIENVENIDO AL SERVICIO DE CONSULTA DE RESERVA DE LA IGLESIA EL CAMINO" />
      </CRow>
      <CRow className="justify-content-center">
        <CCol xs="12" md="9" lg="7" xl="6">
          <CCard>
            <CCardHeader>
              <CButton onClick={history.goBack} color="info" size="sm">
                Regresar
              </CButton>
            </CCardHeader>
            <CCardBody>
              {showQR && code ? (
                <Finish code={code} />
              ) : (
                <BookingByID
                  getReservation={onGetReservation}
                  events={mapEvents()}
                />
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
}

export default Loader((props) => props.loading)(GetReservation);
